import axios from "../../config/axiosConfig";
import {
  PRODUCTION_DETAIL_YARN_REPORT_REQUEST,
  PRODUCTION_DETAIL_YARN_REPORT_SUCCESS,
  PRODUCTION_DETAIL_YARN_REPORT_FAILURE,
  PRODUCTION_DETAIL_YARN_FILTER_REPORT_REQUEST,
  PRODUCTION_DETAIL_YARN_FILTER_REPORT_SUCCESS,
  PRODUCTION_DETAIL_YARN_FILTER_REPORT_FAILURE
} from "../types/production-detail-yarn-report-types";

export const getProductionDetailYarnReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_DETAIL_YARN_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        finyearId: params?.finyearId,
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };

      // Log the request parameters
      console.log('Request Param Datas >>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/production-detail-report/getYarnReport?${queryString}`;

      // Log the full URL (to debug)
      console.log('>>Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('<<<Purchase API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: PRODUCTION_DETAIL_YARN_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching production detail yarn Report:", error);
        dispatch({ type: PRODUCTION_DETAIL_YARN_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching production detail yarn Report:", error);
      dispatch({ type: PRODUCTION_DETAIL_YARN_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getProductionDetailYarnFilterDetail = (params) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: PRODUCTION_DETAIL_YARN_FILTER_REPORT_REQUEST });

            const { auth } = getState();
            const defaultParams = {
                finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth.user?.Customer_Id,
            };
            const requestParams = { ...defaultParams };

            const queryString = new URLSearchParams(requestParams).toString();
            const fullUrl = `/production-detail-report/filter-detail/yarn?${queryString}`;

            console.log('<<Complete API Request URL: ', fullUrl);

            return axios.get(fullUrl).then((response) => {
                console.log('<<purchase-API Response Data: ', response);
                if (response.data) {
                  dispatch({ type: PRODUCTION_DETAIL_YARN_FILTER_REPORT_SUCCESS, payload: response.data });
                }
            }).catch((error) => {
                console.error("Error fetching production detail yarn Report:", error);
                dispatch({ type: PRODUCTION_DETAIL_YARN_FILTER_REPORT_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error("Error fetching production detail yarn Report:", error);
            dispatch({ type: PRODUCTION_DETAIL_YARN_FILTER_REPORT_FAILURE, error: error.message });
        }
    };
};

export const clearProductionDetailYarnReport = () => {
  return async (dispatch) => {
        dispatch({ type: PRODUCTION_DETAIL_YARN_REPORT_SUCCESS, payload: {} });
  }
}
